export default {
  created() {
    document.documentElement.classList.add('custom-layout');
  },
  destroyed() {
    document.documentElement.classList.remove('custom-layout');
  },
};
